import moment from 'moment';

export default function getHeaderByWeekPlanningReseauTempo(h, nbDays, dateStart, dateEnd) {
  const current = moment(dateStart).startOf('day');
  const values = [{ week: current.week(), date: moment(current) }];
  current.add(1, 'weeks');
  while (current.isBefore(dateEnd)) {
    values.push({ week: current.week(), date: moment(current) });
    current.add(1, 'weeks');
  }
  return values.map(v => {
    return h('div', { class: { planningReseauTempoColumn: true } }, [
      h('div', { class: { week: true } }, `S${v.week}`),
      h('time', {
        class: { time: true, ellipsis: true },
        attrs: { datetime: v.date.toISOString() },
      }, `${v.date.format('DD/MM/YYYY')}`),
    ]);
  });
}
